import { render, staticRenderFns } from "./HelpScreenItem.vue?vue&type=template&id=dbacc730&"
import script from "./HelpScreenItem.vue?vue&type=script&lang=js&"
export * from "./HelpScreenItem.vue?vue&type=script&lang=js&"
import style0 from "./HelpScreenItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports